import { apiGet, apiPost, apiPatch } from './client';
import type { TestSessionPublic, TestQuestion, TestResult, TestReviewItem, TestHistoryItem, AssessmentAnalytics, Readiness } from '../types';

export const generateTest = (payload: { type: string; scopeId?: number; config?: Record<string, unknown>; mode?: string }) =>
  apiPost<{ session: TestSessionPublic; questions: TestQuestion[] }>('/assessment/generate', payload);

export const fetchTest = (id: number) =>
  apiGet<{ session: TestSessionPublic; questions: TestQuestion[] }>(`/assessment/tests/${id}`);

export const saveTestProgress = (id: number, body: { answers?: Record<string, number>; marked?: number[] }) =>
  apiPatch<{ ok: boolean }>(`/assessment/tests/${id}`, body);

export const submitTest = (id: number, body: { answers?: Record<string, number>; marked?: number[]; timeTakenSec?: number }) =>
  apiPost<{ result: TestResult }>(`/assessment/tests/${id}/submit`, body);

export const retakeTest = (id: number) =>
  apiPost<{ session: TestSessionPublic }>(`/assessment/tests/${id}/retake`, {});

export const fetchTestResult = (id: number) =>
  apiGet<{ result: TestResult; review: TestReviewItem[] }>(`/assessment/tests/${id}/result`);

export const fetchTestHistory = () => apiGet<TestHistoryItem[]>('/assessment/history');
export const fetchContinueTest = () => apiGet<TestSessionPublic | null>('/assessment/continue');
export const fetchAnalytics = () => apiGet<AssessmentAnalytics>('/assessment/analytics');
export const fetchReadiness = () => apiGet<Readiness>('/assessment/readiness');
